import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { COMMON_CONFIG } from '../../tokens/common-config.token';

export const requestActionInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const { requestAction } = inject(COMMON_CONFIG);

  if (!requestAction) {
    return next(request);
  }

  const updatedRequest = request.clone({
    setHeaders: { 'request-action': requestAction },
  });
  return next(updatedRequest);
};
